import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Label } from "@/components/Shared";
import { Stadtmusikanten } from "@/components/graphics/Marks";
import Snowfall from "@/components/Snowfall";
import { SERVICE_INDEX } from "@/lib/site";

const NotFound = () => (
  <main data-testid="page-404" className="relative overflow-hidden bg-[#062B52] pb-20 pt-[182px] text-white">
    <Seo
      title="Seite nicht gefunden | Bremer Schneemann"
      description="Diese Seite existiert nicht. Hier finden Sie unsere Winterdienst-Leistungen in Bremen."
      path="/404"
    />
    <Snowfall count={20} />
    <Stadtmusikanten className="pointer-events-none absolute -right-6 bottom-0 h-[360px] opacity-[0.08]" color="#FFFFFF" />
    <div className="shell relative z-10">
      <Label tone="orange">/ Fehler 404</Label>
      <h1 className="mt-5 max-w-2xl text-[32px] font-extrabold leading-[1.08] sm:text-[44px] lg:text-[58px]" style={{ color: "#fff" }}>
        Diese Seite haben wir nicht geräumt.
      </h1>
      <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-white/70">
        Die aufgerufene Adresse existiert nicht. Hier geht es zurück zum Winterdienst in Bremen.
      </p>
      <div className="mt-9 flex flex-wrap gap-3">
        <Link to="/" data-testid="notfound-home" className="btn btn-orange h-13 px-6 py-3.5 text-sm">
          Zur Startseite <ArrowUpRight className="h-4 w-4" />
        </Link>
        <Link to="/leistungen" data-testid="notfound-services" className="btn h-13 border border-white/25 px-6 py-3.5 text-sm text-white">
          Alle Leistungen
        </Link>
      </div>
      <div className="mt-14 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICE_INDEX.slice(0, 6).map((s) => (
          <Link
            key={s.to}
            to={s.to}
            className="flex items-center justify-between gap-3 rounded-xl bg-white/[0.06] px-5 py-4 text-[14px] font-medium transition-colors hover:bg-white/[0.12]"
          >
            {s.title}
            <ArrowUpRight className="h-3.5 w-3.5 text-[#FF6B00]" />
          </Link>
        ))}
      </div>
    </div>
  </main>
);

export default NotFound;
